import React from "react";
import PropTypes from "prop-types";
import { Col, Form, Row, Select, Input, Card, Button } from "antd";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import "styles/form.css";

const { TextArea } = Input;
const FormItem = Form.Item;

const prePopulatedReasons = [{
    key: 'CIBIL supported document',
    pre_populated_options: [
        "Customer in OD with",
        "Incorrect document",
        "Need explanation",
        "Others"
    ]
}, {
    key: 'Ledger missing',
    pre_populated_options: [
        "Ledger missing for",
        "Others"
    ]
},
{
    key: 'Old Ledgers',
    pre_populated_options: [
        "Ledger Not updated",
        "Others"
    ]
},
{
    key: 'Reco letter',
    pre_populated_options: [
        "Reco letter required",
        "Others"
    ]
},
{
    key: 'Bank Statement',
    pre_populated_options: [
        "Bank statement missing for ",
        "Incomplete bank statement",
        "Payment not matching",
        "Others"
    ]
},
{
    key: "Doc Pending",
    pre_populated_options: [
        "Doc pending- Doc name",
        "OSV",
        "VKYC",
        "Others"
    ]
}, {
    key: "Guarantor KYC",
    pre_populated_options: [
        "Guarantor KYC required",
        "Others"
    ]
},
{
    key: "GST filing",
    pre_populated_options: [
        "GST filing missing for the month of",
        "Others"
    ]
},
{
    key: "Other GST issue",
    pre_populated_options: [
        "Cancelled GST",
        "Incomplete GST",
        "Others"
    ]
},
{
    key: "Other",
    pre_populated_options: [
        "Others"
    ]
},
{
    key: 'Info Pending',
    pre_populated_options: [
        "Details not available for",
        "Others"
    ]
},
{
    key: 'Hold',
    pre_populated_options: [
        "On hold because",
        "Others"
    ]
},
{
    key: 'Reject',
    pre_populated_options: [
        "Rejecting because",
        "Others"
    ]
},
{
    key: 'Incorrect Ledger',
    pre_populated_options: [
        "Incorrect ledger for",
        "Others"
    ]
},
{
    key: 'Financials',
    pre_populated_options: [
        "Old Financials",
        "Others"
    ]
},
{
    key: 'Distributor Related',
    pre_populated_options: [
        "DB KYC pending",
        "DB portfolio in OD",
        "Others"
    ]
},
{
    key: 'Portfolio Related',
    pre_populated_options: [
        "Unsatisfactory customer record",
        "DB portfolio in OD",
        "Anchor on hold",
        "Industry on hold",
        "Others"
    ]
},
{
    key: 'Customer not reachable',
    pre_populated_options: [
        "PD Call",
        "Others"
    ]
}]


const prePopulatedReasons_credit = [
  {
    key: "Cibil/RTR supported documents",
    pre_populated_options: [
      "Customer in OD with",
      "Incorrect document",
      "Need explanation",
      "Others"
    ]
  },
  {
    key: "Banking documents",
    pre_populated_options: [
      "Bank statement missing for",
      "Incomplete bank statement",
      "Payment not matching",
      "Others"
    ]
  },
  {
    key: "TVR issues",
    pre_populated_options: [
      "PD call"
    ]
  },
  {
    key: "Financial documents",
    pre_populated_options: [
      "Financials incomplete",
      "Provisionals",
      "Latest stock/Debtors/Creditors statement"
    ]
  },
  {
    key: "GST related documents",
    pre_populated_options: [
      "GST filling",
      "GST suspended",
      "Incomplete GST"
    ]
  },
  {
    key: "Ledger related documents",
    pre_populated_options: [
      "Ledger missing",
      "Incomplete Ledger",
      "Others"
    ]
  },
  {
    key: "Anchor/DB repayment portfolio/hold/50:50",
    pre_populated_options: [
      "Anchor/DB currently in overdue clearance",
      "Anchor/DB repayment plan",
      "Anchor/DB not aligned(50:50 req)"
    ]
  },
  {
    key: "E-Bill",
    pre_populated_options: [
      "E-Bill",
      "Property tax"
    ]
  },
  {
    key: "Co-app or Guarantor req",
    pre_populated_options: [
      "Guarantor KYC required",
      "Others"
    ]
  },
//   {
//     key: "Anchor/DB not aligned(50:50 req)",
//     pre_populated_options: [
//       "Anchor/DB not aligned(50:50 req)"
//     ]
//   },
  {
    key: "Hold as per sales",
    pre_populated_options: [
      "Sales request"
    ]
  },
  {
    key: "BT documents required",
    pre_populated_options: [
      "Sanction letter",
      "SOA",
      "Anchor confirmation"
    ]
  },
  {
    key: "Group firm documents",
    pre_populated_options: [
      "Grup firm financials",
      "KYC",
      "others"
    ]
  },
  {
    key: "Partnership deed/Pvt Ltd related docs",
    pre_populated_options: [
      "Partnership deed",
      "Shareholding pattern",
      "others"
    ]
  },
  {
    key: "Recommetion letter from sales head/Anchor/RBH",
    pre_populated_options: [
      "Reco from anchor",
      "Reco from RH/BH/ZH"
    ]
  },
  {
    key: "Scheme issues/ROI approvals",
    pre_populated_options: [
      "Scheme to be corrected"
    ]
  }
];


class ReferToSaleCoordinatorModal extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    state = {
        remarks: "",
        reason: "",
        stage: null,
        selected_user: null,
        disableForm: true,
        documentRequestModel: false,
        reasonId: null,
        subCategoryId: null,
        refer_reasons_list: [],
    };

    onChangeRemarks = () => {
        if (!this.state.refer_reasons_list.some(_ => Object.values(_).some(x => x === null || x === ''))) {
            this.props.updateReferToSalesCoordinatorStage(this.state.refer_reasons_list)
        } else {
            this.props.disableSubmit();
        }
    };


    onChangeReferReasons = (index, pre_populated_remarks, refer_remarks, refer_reason_category) => {
        if (this.props.referReasonsList.filter(_ => _.id == refer_reason_category)[0].name.toLowerCase() == "doc pending" && pre_populated_remarks == "") {
            this.props.showDocumentRequestModal();
        }
        let data = [...this.state.refer_reasons_list];
        let obj = {};
        if (data[index] && data[index]['refer_reason_category'] != refer_reason_category) {
            obj = { 'pre_populated_remarks': '', 'refer_remarks': '', 'refer_reason_category': refer_reason_category }
        } else if (data[index] && data[index]['pre_populated_remarks'] != pre_populated_remarks) {
            obj = { 'pre_populated_remarks': pre_populated_remarks, 'refer_remarks': '', 'refer_reason_category': refer_reason_category }
        } else {
            obj = { 'pre_populated_remarks': pre_populated_remarks, 'refer_remarks': refer_remarks, 'refer_reason_category': refer_reason_category }
        }

        data[index] = obj
        this.setState({
            refer_reasons_list: data
        }, () => {
            this.onChangeRemarks()
        })
    }

    checkFieldEnabled = (index) => {
        const { refer_reasons_list } = this.state;

        if (index != 0 && !refer_reasons_list[index - 1]) {
            return true;
        } else if (refer_reasons_list[index - 1] && !refer_reasons_list[index - 1].refer_remarks) {
            if (refer_reasons_list[index]) {
                return false;
            }
            return true;
        }
        return false;
    }

    clearReason = (index) => {
        let data = [...this.state.refer_reasons_list];
        data.splice(index, 1);;

        this.setState({
            refer_reasons_list: data
        }, () => {
            this.onChangeRemarks()
        })
    }

    render() {
        const { refer_reasons_list } = this.state;
        const populated_reasons = [7,8,54].includes(this.props.stageId) ? prePopulatedReasons_credit : prePopulatedReasons;
        return (
            <React.Fragment>
                {[0, 1, 2].map((index, k) => {
                    let pre_populated_remarks = refer_reasons_list[index] ? refer_reasons_list[index].pre_populated_remarks : '';
                    let refer_remarks = refer_reasons_list[index] ? refer_reasons_list[index].refer_remarks : '';
                    let refer_reason_category = refer_reasons_list[index] ? refer_reasons_list[index].refer_reason_category : '';
                    let refer_reason_cat_name = refer_reason_category ? this.props.referReasonsList.filter(reason => reason.id == refer_reason_category)[0].name : '';
                    return <Row className={"mt-10"}>
                        <Card>
                            <h4 style={{ display: "inline-block" }}>Referback Reason {index + 1}</h4>
                            {index != 0 && <Button disabled={this.checkFieldEnabled(index)} onClick={() => this.clearReason(index)} style={{ float: "right" }}>Clear</Button>}
                            <Row className={"mt-10"}>
                                <Col span={24}>
                                    <FormItem help={refer_reasons_list[index] && !refer_reason_category ? "Field is required" : ""}>
                                        <Select style={{ width: "100%" }}
                                            disabled={this.checkFieldEnabled(index)}
                                            value={refer_reason_category ? refer_reason_category : undefined}
                                            onChange={(val) => this.onChangeReferReasons(k, pre_populated_remarks, refer_remarks, val)}
                                            placeholder="Select Reason"
                                        >
                                            {this.props.referReasonsList && this.props.referReasonsList.map((reason, k) => (
                                                <Option value={reason.id}>{reason.name}</Option>
                                            ))}
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <FormItem help={refer_reasons_list[index] && !pre_populated_remarks ? "Field is required" : ""}>
                                        <Select
                                            placeholder="Select Default Remark"
                                            style={{ width: "100%" }}
                                            value={pre_populated_remarks ? pre_populated_remarks : undefined}
                                            onChange={(val) => this.onChangeReferReasons(k, val, refer_remarks, refer_reason_category)}
                                            disabled={!refer_reason_category || this.checkFieldEnabled(index)}
                                        >
                                            {/* {refer_reason_category != '' && populated_reasons.filter(populatedReason => populatedReason.key == refer_reason_cat_name)[0]['pre_populated_options'].map(prePopulateItem => (
                                                <Option value={prePopulateItem}>{prePopulateItem}</Option>
                                            ))} */}
                                            {refer_reason_category !== '' &&
                                                populated_reasons
                                                    .find(reason => reason.key === refer_reason_cat_name)
                                                    ?.pre_populated_options
                                                    ?.map(prePopulateItem => (
                                                    <Option key={prePopulateItem} value={prePopulateItem}>
                                                        {prePopulateItem}
                                                    </Option>
                                                    ))
                                                }
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <FormItem help={refer_reasons_list[index] && !refer_remarks ? "Field is required" : ""}>
                                        <TextArea
                                            onChange={(e) => this.onChangeReferReasons(k, pre_populated_remarks, e.target.value, refer_reason_category)}
                                            value={refer_remarks}
                                            rows={2}
                                            placeholder={"Refer Remarks"}
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                        </Card>
                    </Row>
                })}
            </React.Fragment>
        );
    }
}

ReferToSaleCoordinatorModal.propTypes = {
    onChange: PropTypes.func,
    form: PropTypes.object,
    rejectReason: PropTypes.object,
    stageId: PropTypes.number,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    referReasonsList: PropTypes.array,
    updateReferToSalesCoordinatorStage: PropTypes.func,
    disableSubmit: PropTypes.func,
    showDocumentRequestModal: PropTypes.func
};

export default Form.create({})(ReferToSaleCoordinatorModal);